import React, { useContext, useEffect, useRef, useState } from "react";

import axios from "axios";
import SuccessIcon from "../../../images/success_icon.svg";
import ErrorIcon from "../../../images/error_icon.svg";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AddToBasketIcon from "../../../images/orders/orders.svg";
import ExecutetickIconLight from "../../../images/orders/execute.svg";
import ExecutetickIconDark from "../../../images/orders/tick-circle.svg";
import WebsocketWrapperContext from "../../../context/WebsocketWrapperContext";
import CommonModal from "../../../modals/CommonModal";
import { useTheme } from "../../../context/ThemeContext";
import { ButtonContext } from "../../../context/ButtonsContext";
import { useBuySellModalContext } from "../../../context/BuySellModalContext";
import { useFundsData } from "../../../context/FundsDataContext";
import CustomToastContent from "../../../components/CustomToastContent";
import { useStatus } from "../../../context/StatusProvider";
import { getCookie } from "../../../utils/cookieUtils";
const OrdersBuySellModal = ({
  orderData,
  modalOpen,
  modalClose,
  isOrders,
  setIsBuySellModalOpen,
  fetchOrders,
  handleAddToBasket,
}) => {
  const { theme } = useTheme();
  const { isLive, isVirtual } = useContext(ButtonContext);

  const {
    buySellModalData,
    setBuySellModalData,
    toggleBuySellStatus,
    handleIncrement,
    handleDecrement,
    clearBuySellModalData,
    handlePriceChange,
    handleTriggerPriceChange,
    isMultipleOfFiveCents,
  } = useBuySellModalContext();
  const { symbolData } = useContext(WebsocketWrapperContext);
  const broker = localStorage.getItem("broker");
  const access_token = getCookie("access_token");
  const client_id = getCookie("client_id");
  const [activeBuySellOption, setActiveBuySellOption] = useState("buy");
  const [activeIntradayNormalOption, setActiveIntradayNormalOption] =
    useState("");

  const getDefaultOrderType = (firstOrderType) => {
    switch (firstOrderType) {
      case "MARKET":
        return "marketorder";
      case "LIMIT":
        return "limitorder";
      case "TRIGGER":
        return "triggerorder";
      default:
        return "triggerorder";
    }
  };

  const [marginRequired, setMarginRequired] = useState(null);
  const [charges, setCharges] = useState(null);
  const { fundsData, fetchBalanceAPI } = useFundsData();
  const [lots, setLots] = useState(1);
  const [price, setPrice] = useState("");
  const [trigger_price, setTriggerPrice] = useState("");
  const [lot_size, setLot_size] = useState(1);
  const [orderType, setOrderType] = useState(
    getDefaultOrderType(buySellModalData[0]?.orderType)
  );
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [priceError, setPriceError] = useState(""); // Error state for price
  const [triggerPriceError, setTriggerPriceError] = useState("");
  const { status, setStatus } = useStatus();
  const [isPriceEnabled, setIsPriceEnabled] = useState(
    true
      ? getDefaultOrderType(buySellModalData[0]?.orderType) == "limitorder" ||
          getDefaultOrderType(buySellModalData[0]?.orderType) == "triggerorder"
      : false
  );
  const [isTriggerPriceEnabled, setIsTriggerPriceEnabled] = useState(
    true
      ? getDefaultOrderType(buySellModalData[0]?.orderType) == "triggerorder"
      : false
  );

  // Stoploss and Target state
  const [stoploss, setStoploss] = useState("");
  const [target, setTarget] = useState("");
  const [isCO, setIsCO] = useState(false);
  const [isBO, setIsBO] = useState(false);
  const [stoplossError, setStoplossError] = useState("");
  const [targetError, setTargetError] = useState("");

  const handleOrderTypeChange = (type, shouldResetPrice = true) => {
    // Check if trying to change from Limit when CO or BO is active
    if ((isCO || isBO) && type !== "limitorder") {
      toast.error("Only Limit order type is allowed for BO and CO orders.");
      return;
    }

    setOrderType(type);
    const currentLTP = symbolData[buySellModalData[0]?.code]?.ltp || "0.0";
    let updatedData = [...buySellModalData];
    if (type === "marketorder") {
      setPrice(currentLTP);
      setIsPriceEnabled(false);
      setIsTriggerPriceEnabled(false);
      setTriggerPrice("0");
    } else if (type === "limitorder") {
      setPrice(currentLTP);
      setIsPriceEnabled(true);
      setTriggerPrice("0");
      setIsTriggerPriceEnabled(false);
      buySellModalData[0].price =
        type !== "marketorder" ? currentLTP : undefined;
    } else if (type === "triggerorder") {
      setTriggerPrice(currentLTP);
      setIsPriceEnabled(true);
      setIsTriggerPriceEnabled(true);
      updatedData = [...buySellModalData];
      updatedData[0].trigger_price = currentLTP;
    }
    // Update context data without overriding existing price
    updatedData[0].orderType =
      type === "marketorder"
        ? "MARKET"
        : type === "limitorder"
          ? "LIMIT"
          : "TRIGGER";

    setBuySellModalData(updatedData);
  };

  const handleCOCheckbox = (checked) => {
    setIsCO(checked);
    if (checked) {
      setIsBO(false); // Uncheck BO if CO is checked
      // Automatically set order type to Limit if it's not already
      if (orderType !== "limitorder") {
        handleOrderTypeChange("limitorder");
      }
    } else {
      // Clear stoploss when unchecked
      setStoploss("");
      setStoplossError("");
    }
  };

  const handleBOCheckbox = (checked) => {
    setIsBO(checked);
    if (checked) {
      setIsCO(false); // Uncheck CO if BO is checked
      // Automatically set order type to Limit if it's not already
      if (orderType !== "limitorder") {
        handleOrderTypeChange("limitorder");
      }
    } else {
      // Clear stoploss and target when unchecked
      setStoploss("");
      setTarget("");
      setStoplossError("");
      setTargetError("");
    }
  };

  const handleStoplossChange = (e) => {
    const value = e.target.value;
    // Allow empty string, numbers, and decimal point
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setStoploss(value);
      setStoplossError("");
    }
  };

  const handleTargetChange = (e) => {
    const value = e.target.value;
    // Allow empty string, numbers, and decimal point
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setTarget(value);
      setTargetError("");
    }
  };

  const getOrderType = () => {
    switch (orderType) {
      case "marketorder":
        return "MARKET";
      case "limitorder":
        return "LIMIT";
      case "triggerorder":
        return "TRIGGER";
      default:
        return "TRIGGER";
    }
  };

  //   const handleOrderTypeChange = (type) => {
  //     setOrderType(type);

  //     const currentLTP = symbolData[buySellModalData[0].code]?.ltp || "0.0";

  //     if (type === "marketorder") {
  //       setIsPriceEnabled(false); // Disable price input
  //       setIsTriggerPriceEnabled(false); // Disable trigger price input
  //       // For market orders, still set the price to LTP (though it's disabled)
  //       setPrice(buySellModalData[0]?.price);
  //       setTriggerPrice("0");
  //     } else if (type === "limitorder") {
  //       setIsPriceEnabled(true); // Enable price input
  //       setIsTriggerPriceEnabled(false); // Disable trigger price input
  //       // For limit orders, set the price to the current LTP
  //       setPrice(buySellModalData[0]?.price);
  //       setTriggerPrice("0");
  //     } else if (type === "triggerorder") {
  //       setIsPriceEnabled(true); // Enable price input
  //       setIsTriggerPriceEnabled(true); // Enable trigger price input
  //       // For trigger orders, set both price and trigger price to LTP
  //       setPrice(buySellModalData[0]?.price);
  //       setTriggerPrice(currentLTP);
  //     }

  //     if (type === "limitorder") {
  //       buySellModalData[0].orderType = "LIMIT";
  //     } else if (type === "triggerorder") {
  //       buySellModalData[0].orderType = "TRIGGER";
  //     } else {
  //       buySellModalData[0].orderType = "MARKET";
  //     }

  //     // Update the order price in your data model
  //     buySellModalData[0].price = type !== "marketorder" ? currentLTP : undefined;
  //   };

  //   useEffect(() => {
  //     if (buySellModalData.length > 0 && buySellModalData[0]) {
  //       const currData = buySellModalData[0];

  //       // Set Normal or Intraday option
  //       setActiveIntradayNormalOption(
  //         currData.productType === "Normal" ? "normal" : "intraday"
  //       );
  //       // Handle Market, Limit, and Trigger orders
  //       if (currData.orderType === "MARKET") {
  //         handleOrderTypeChange("marketorder");
  //       } else if (currData.orderType === "LIMIT") {
  //         handleOrderTypeChange("limitorder");
  //       } else if (currData.orderType === "TRIGGER") {
  //         handleOrderTypeChange("triggerorder");
  //         if (currData.trigger_price) {
  //           //   setPrice(currData.tradedPrice);
  //           setTriggerPrice(currData.trigger_price); // Set the trigger price for trigger/TRIGGER orders
  //         }
  //       }
  //     }
  //   }, [activeIntradayNormalOption, orderType]);

  // useEffect(() => {
  //   if (buySellModalData.length > 0 && buySellModalData[0]) {
  //     const currData = buySellModalData[0];
  //     setActiveIntradayNormalOption(
  //       currData.productType === "Normal" ? "normal" : "intraday"
  //     );
  //     // Set initial price directly from context
  //     setPrice(currData.price || "");
  //     setTriggerPrice(currData.trigger_price || "");

  //     // Set order type AFTER setting initial prices
  //     if (currData.orderType === "MARKET") {
  //       handleOrderTypeChange("marketorder", false);
  //     } else if (currData.orderType === "LIMIT") {
  //       handleOrderTypeChange("limitorder", false);
  //     } else if (currData.orderType === "TRIGGER") {
  //       handleOrderTypeChange("triggerorder", false);
  //     }
  //   }
  // }, [orderType]);

  const handleBuySellToggle = (option) => {
    if (buySellModalData?.length === 0) return;
    const updatedModalData = [
      {
        ...buySellModalData[0],
        buy_sell: option === "buy" ? "B" : "S",
      },
      ...buySellModalData.slice(1),
    ];

    setBuySellModalData(updatedModalData);
  };

  const handleIntradayNormalToggle = (option) => {
    if (buySellModalData?.length === 0) return;
    const updatedModalData = [
      {
        ...buySellModalData[0],
        productType: option === "normal" ? "Normal" : "Intraday",
      },
      ...buySellModalData.slice(1),
    ];

    setActiveIntradayNormalOption(option);
    setBuySellModalData(updatedModalData);
  };

  const handleLotSizeChange = (newValue) => {
    // Allow empty string during typing, but ensure valid number
    if (newValue === '') {
      setLots('');
      return;
    }
    
    const newLotsSize = parseInt(newValue);
    if (isNaN(newLotsSize) || newLotsSize < 1) {
      return; // Don't update if invalid
    }

    const updatedData = [...buySellModalData];
    const dataObject = updatedData[0];
    dataObject.lotSize = newLotsSize;
    setBuySellModalData(updatedData);
    setLots(newLotsSize);
  };

  const handleLotSizeBlur = () => {
    // When user clicks outside, ensure minimum 1
    if (lots === '' || isNaN(lots) || lots < 1) {
      setLots(1);
      const updatedData = [...buySellModalData];
      const dataObject = updatedData[0];
      dataObject.lotSize = 1;
      setBuySellModalData(updatedData);
    }
  };


  function formatNumberWithCommasAndFontWeight(value) {
    const formattedValue = parseFloat(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const parts = formattedValue.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1];

    return (
      <span>
        {integerPart}.<span style={{ fontWeight: 400 }}>{decimalPart}</span>
      </span>
    );
  }

  const handleToastToNavigate = (response) => {
    navigate(response.page);
  };

  const handleExecuteOrder = async () => {
    setIsBuySellModalOpen(true);
    setPriceError("");
    setTriggerPriceError("");
    setStoplossError("");
    setTargetError("");

    if (!isMultipleOfFiveCents(price)) {
      setPriceError(
        "Price should be multiple of Tick size " +
          symbolData[buySellModalData[0]?.code]?.tick_size
      );

      // Resetting error(just css causing issues)
      setTimeout(() => {
        setPriceError("");
      }, 3000);

      return;
    }

    if (isTriggerPriceEnabled && !isMultipleOfFiveCents(trigger_price)) {
      setTriggerPriceError(
        "Trigger price should be a multiple of Tick size " +
          symbolData[buySellModalData[0]?.code]?.tick_size
      );

      setTimeout(() => {
        setTriggerPriceError("");
      }, 3000);

      return;
    }

    // Validate stoploss and target for CO/BO
    const tickSize = parseFloat(symbolData[buySellModalData[0]?.code]?.tick_size || 0.05);

    if (isCO || isBO) {
      // Check if stoploss is empty
      if (!stoploss || stoploss.trim() === "") {
        setStoplossError("Stoploss cannot be empty for CO/BO orders.");
        setTimeout(() => setStoplossError(""), 3000);
        return;
      }

      const stoplossValue = parseFloat(stoploss);

      // Check if stoploss is a valid positive number
      if (isNaN(stoplossValue) || stoplossValue <= 0) {
        setStoplossError("Stoploss must be a valid positive number.");
        setTimeout(() => setStoplossError(""), 3000);
        return;
      }

      // Check if stoploss is a multiple of tick size
      const ratio = stoplossValue / tickSize;
      if (Math.abs(ratio - Math.round(ratio)) > 0.0001) {
        setStoplossError(`Stoploss should be a multiple of ${tickSize}`);
        setTimeout(() => setStoplossError(""), 3000);
        return;
      }

      // Validate stoploss range: 1 to 70% of order price
      const orderPrice = parseFloat(price);
      if (!isNaN(orderPrice) && orderPrice > 0) {
        const maxStoploss = parseFloat((orderPrice * 0.70).toFixed(2));
        if (stoplossValue < 1 || stoplossValue > maxStoploss) {
          setStoplossError(`Stoploss must be between 1 and ${maxStoploss}.`);
          setTimeout(() => setStoplossError(""), 3000);
          return;
        }
      }
    }

    if (isBO) {
      // Check if target is empty
      if (!target || target.trim() === "") {
        setTargetError("Target cannot be empty for BO orders.");
        setTimeout(() => setTargetError(""), 3000);
        return;
      }

      const targetValue = parseFloat(target);

      // Check if target is a valid positive number
      if (isNaN(targetValue) || targetValue <= 0) {
        setTargetError("Target must be a valid positive number.");
        setTimeout(() => setTargetError(""), 3000);
        return;
      }

      // Check if target is a multiple of tick size
      const targetRatio = targetValue / tickSize;
      if (Math.abs(targetRatio - Math.round(targetRatio)) > 0.0001) {
        setTargetError(`Target should be a multiple of ${tickSize}`);
        setTimeout(() => setTargetError(""), 3000);
        return;
      }
    }

    try {
      let response;
      // Clear the basketData array by removing all items
      if (buySellModalData?.[0]?.isModify){
        const payload = generateModifyOrderPayload();
        response = await sendModifyOrder(payload);
      } else {
        if (isLive){
          const payload = generateOrderPayload();
          response = await sendOrder(payload);
        } else {
          const payload = generateVirtualOrderPayload();
          response = await sendVirtualOrder(payload);
        }
      }
      fetchBalanceAPI();
      if (response.status) {
        toast.success(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-success-toast",
            icon: <img src={SuccessIcon} alt="Success Icon" />,
            onClick: () => handleToastToNavigate(response),
          }
        );
        clearBuySellModalData();
        modalClose();
        fetchOrders();
      } else {
        toast.error(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-error-toast",
            icon: <img src={ErrorIcon} alt="Error Icon" />,
          }
        );
      }
    } catch (error) {
      console.error("Error executing order:", error);
      toast.error(
        <CustomToastContent
          heading="Error executing order"
          message={error.message}
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
    }
  };

  const handleExecuteVirtualOrder = async () => {
    try {
      const payload = generateVirtualOrderPayload();
      const response = await sendVirtualOrder(payload);
      if (response.status) {
        toast.success(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-success-toast",
            icon: <img src={SuccessIcon} alt="Success Icon" />,
            onClick: () => handleToastToNavigate(response),
          }
        );
      } else {
        toast.error(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-error-toast",
            icon: <img src={ErrorIcon} alt="Error Icon" />,
          }
        );
      }
      clearBuySellModalData();
      modalClose();
      fetchOrders();
    } catch (error) {
      console.error("Error executing virtual order:", error);
      toast.error(
        <CustomToastContent
          heading="Error executing virtual order"
          message={error.message}
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
    }
  };

  const handleModifyOrder = async () => {
    setIsBuySellModalOpen(false);

    setPriceError("");
    setTriggerPriceError("");

    if (!isMultipleOfFiveCents(price)) {
      setPriceError("Price should be multiple of Tick size 0.05");
      setTimeout(() => {
        setPriceError("");
      }, 3000);

      return;
    }

    if (isTriggerPriceEnabled && !isMultipleOfFiveCents(trigger_price)) {
      setTriggerPriceError(
        "Trigger price should be a multiple of Tick size 0.05"
      );

      setTimeout(() => {
        setTriggerPriceError("");
      }, 3000);

      return;
    }
    try {
      const payload = generateModifyOrderPayload();
      const response = await sendModifyOrder(payload);
      fetchBalanceAPI();
      if (response.status) {
        setStatus(response.status);
        toast.success(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-success-toast",
            icon: <img src={SuccessIcon} alt="Success Icon" />,
            onClick: () => handleToastToNavigate(response),
          }
        );
        fetchOrders();
      } else {
        toast.error(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-error-toast",
            icon: <img src={ErrorIcon} alt="Error Icon" />,
          }
        );
      }
    } catch (error) {
      console.error("Error executing virtual order:", error);
      toast.error(
        <CustomToastContent
          heading="Error executing virtual order"
          message={error.message}
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
    }
  };

  const generateOrderPayload = () => {
    const orderList = buySellModalData.map((currData, ind) => ({
      isBuy: currData.buy_sell === "B" ? true : false,
      isCall: currData.side === "Call" ? true : false,
      isFut: false,
      code: currData.code,
      exchange: currData.exchange,
      productType: activeIntradayNormalOption === "normal" ? "NRML" : "MIS",
      orderType: getOrderType(),
      quantity: currData.lotSize * currData.lot_size,
      price: currData.price,
      trigger_price: currData.trigger_price,
      lot_size: currData.lot_size,
      freeze_qty: currData.freeze_qty,
      strike: currData.strike,
      expiry: currData.expiryDate,
      tradingSymbol: currData.tradingSymbol,
      lot_multiplier: currData.lot_multiplier,
      scrip: currData.scrip,
      sl_type: (isCO || isBO) ? "Abs value" : null,
      sl_value: (isCO || isBO) ? stoploss : null,
      target_type: isBO ? "Abs value" : null,
      target_value: isBO ? target : null,
    }));
    return {
      order_list: orderList,
      broker: broker,
      access_token: access_token,
      client_id: client_id,
    };
  };

  const generateModifyOrderPayload = () => {
    const orderList = buySellModalData.map((currData, ind) => ({
      order_id: currData.orderId,
      isBuy: currData.buy_sell === "B" ? true : false,
      isCall: currData.side === "Call" ? true : false,
      isFut: false,
      code: currData.code,
      exchange: currData.exchange,
      productType: activeIntradayNormalOption === "normal" ? "NRML" : "MIS",
      orderType: getOrderType(),
      quantity: currData.lotSize * currData.lot_size,
      price: currData.price,
      trigger_price: currData.trigger_price,
      lot_size: currData.lot_size,
      freeze_qty: currData.freeze_qty,
      strike: currData.strike,
      expiry: currData.expiryDate,
      tradingSymbol: currData.tradingSymbol,
      lot_multiplier: currData.lot_multiplier,
      scrip: currData.scrip,
      sl_type: (isCO || isBO) ? "Abs value" : null,
      sl_value: (isCO || isBO) ? stoploss : null,
      target_type: isBO ? "Abs value" : null,
      target_value: isBO ? target : null,
    }));
    return {
      order_list: orderList,
      broker: broker,
      main_broker: broker,
      access_token: access_token,
      client_id: client_id,
    };
  };

  const sendModifyOrder = async (payload) => {
    try {
      const response = await axios.post(
        "https://s2ox3qi5zk.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_modify_order",
        payload
      );
      return response.data;
    } catch (error) {
      // console.log("Error modifying order:", error);
      return {
        status: false,
        message_header: "Error modifying order",
        message_body: error.message,
      };
    }
  };

  const generateVirtualOrderPayload = () => {
    const orderList = buySellModalData.map((currData, ind) => ({
      isBuy: currData.buy_sell === "B" ? true : false,
      isCall: currData.side === "Call" ? true : false,
      isFut: false,
      code: currData.code,
      exchange: currData.exchange,
      productType: activeIntradayNormalOption === "normal" ? "NRML" : "MIS",
      orderType: getOrderType(),
      quantity: currData.lotSize * currData.lot_size,
      price: currData.price,
      trigger_price: currData.trigger_price,
      lot_size: currData.lot_size,
      freeze_qty: currData.freeze_qty,
      strike: currData.strike,
      expiry: currData.expiry,
      tradingSymbol: currData.tradingSymbol,
      lot_multiplier: currData.lot_multiplier,
      scrip: currData.scrip,
      expiry: currData.expiryDate,
      sl_type: (isCO || isBO) ? "Abs value" : null,
      sl_value: (isCO || isBO) ? stoploss : null,
      target_type: isBO ? "Abs value" : null,
      target_value: isBO ? target : null,
    }));
    return {
      order_list: orderList,
      broker: "virtual",
      main_broker: broker,
      access_token: access_token,
      client_id: client_id,
    };
  };

  const sendVirtualOrder = async (payload) => {
    try {
      const response = await axios.post(
        "https://hgb1gw5n6g.execute-api.ap-south-1.amazonaws.com/default/og_virtual_placeorder",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error placing order:", error);
      return {
        status: false,
        message_header: "Error placing order",
        message_body: error.message,
      };
    }
  };

  const handleBuySellCloseClick = () => {
    clearBuySellModalData();
    modalClose();
  };

  const sendOrder = async (payload) => {
    try {
      const response = await axios.post(
        "https://0eo1dv23p5.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_placeorder",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error placing order:", error);
      return {
        status: false,
        message_header: "Error placing order",
        message_body: error.message,
      };
    }
  };

  useEffect(() => {
    const generateMarginPayload = () => {
      const orderList = buySellModalData.map((currData, ind) => ({
        isBuy: currData.buy_sell === "B" ? true : false,
        isCall: currData.side === "Call" ? true : false,
        isFut: currData.isFuture || false,
        code: currData.code,
        exchange: currData.exchange,
        productType: activeIntradayNormalOption === "normal" ? "NRML" : "MIS",
        orderType: getOrderType(),
        quantity: currData.lotSize * currData.lot_size,
        price: currData.price,
        trigger_price: currData.trigger_price,
        lot_size: currData.lot_size,
        strike: currData.strike,
        expiry: currData.expiryDate,
        tradingSymbol: currData.tradingSymbol,
        lot_multiplier: currData.lot_size,
        scrip: currData.scrip,
      }));
      return {
        order_list: orderList,
        broker: broker,
        access_token: access_token,
        client_id: client_id,
      };
    };

    const fetchMarginRequired = async () => {
      try {
        const payload = generateMarginPayload();

        const response = await axios.post(
          "https://7mwh6csmrh.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_margin",
          payload
        );
        setMarginRequired(response.data.finalMargin);
      } catch (error) {
        console.error("Error getting margin required:", error);
      }
    };

    const fetchCharges = async () => {
      try {
        const payload = await generateMarginPayload();
        const response = await axios.post(
          "https://pc933vy3c6.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_charges",
          payload
        );
        setCharges(response.data.total_charges);
      } catch (error) {
        console.error("Error getting charges required:", error);
      }
    };

    fetchMarginRequired();
    fetchCharges();
  }, [buySellModalData]);

  useEffect(() => {
    setLots(buySellModalData[0]?.lotSize);
    setPrice(buySellModalData[0]?.price);
    setTriggerPrice(buySellModalData[0]?.trigger_price);
    setLot_size(buySellModalData[0]?.lot_size);
    if (buySellModalData[0]?.buy_sell === "S") {
      setActiveBuySellOption("sell");
    } else if (buySellModalData[0]?.buy_sell === "B") {
      setActiveBuySellOption("buy");
    }

    if (buySellModalData[0]?.productType === "Intraday") {
      setActiveIntradayNormalOption("intraday");
    } else if (buySellModalData[0]?.productType === "Normal") {
      setActiveIntradayNormalOption("normal");
    }
  }, [buySellModalData]);

  const handlePriceKeyPress = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();

      let currentPrice = parseFloat(buySellModalData[0].price) || 0;
      const incrementValue = 0.05;

      if (e.key === "ArrowUp") {
        currentPrice = parseFloat((currentPrice + incrementValue).toFixed(3));
      } else if (e.key === "ArrowDown") {
        currentPrice = parseFloat((currentPrice - incrementValue).toFixed(3));
        if (currentPrice < 0) currentPrice = 0;
      }

      const updatedItem = {
        ...buySellModalData[0],
        price: currentPrice.toString(),
      };
      setBuySellModalData([updatedItem]);
    }
  };
  //   useEffect(() => {
  //     if (buySellModalData[0]?.price !== price) {
  //       const updatedData = [...buySellModalData];
  //       updatedData[0].price = price;
  //       setBuySellModalData(updatedData);
  //     }
  //   }, [price]);

  //   useEffect(() => {
  //     if (buySellModalData[0]?.trigger_price !== trigger_price) {
  //       const updatedData = [...buySellModalData];
  //       updatedData[0].trigger_price = trigger_price;
  //       setBuySellModalData(updatedData);
  //     }
  //   }, [trigger_price]);
  const LtpWidget = ({ code }) => {
    const ltpPrice = symbolData[code]?.ltp || 0;
    const pctChange = symbolData[code]?.pctChange || 0;
    const changeColor = pctChange >= 0 ? "text-p150" : "text-[#B01431]";

    return (
      <div className="flex items-center">
        <span className="text-xl font-bold text-p300">{ltpPrice}</span>
        <span className={`ml-2 text-xs font-medium ${changeColor}`}>
          {pctChange >= 0 ? "+" : ""}
          {pctChange}%
        </span>
      </div>
    );
  };

  return (
    <div className={`modal ${modalOpen ? "modal-open" : ""}`}>
      {/* Modal Content */}
      <div className="modal-box p-0 max-w-sm bg-modalBg shadow-xl rounded-lg overflow-hidden border-1">
        <div>
          {/* Header */}
          <div className="p-4 flex justify-between items-center w-full">
            {Array.isArray(buySellModalData) && buySellModalData?.length > 0 ? (
              <div>
                <h2 className="font-semibold text-base text-p300">
                  {buySellModalData[0]?.instrumentName || "Instrument name..."}
                </h2>
                <div className="mt-1">
                  <LtpWidget code={buySellModalData[0]?.code} />
                </div>
              </div>
            ) : (
              <div>
                <h2 className="font-semibold text-base text-p300">
                  Instrument name...
                </h2>
                <div className="mt-1">
                  <LtpWidget code={null} />
                </div>
              </div>
            )}
            <form method="dialog">
              <button
                type="button"
                className="btn text-p300 btn-sm bg-p400 hover:bg-n100 btn-circle"
                onClick={modalClose}>
                ✕
              </button>
            </form>
          </div>

          {/* Buy/Sell and Intraday/Normal Toggles */}
          <div className="px-4 pb-3 flex justify-between items-center">
            {/* Buy/Sell Toggle */}
            <div className="border border-[#CFCFCF] rounded-[4px] p-0.5 w-[106px] h-8 flex bg-n000">
              <button
                className={`flex-1 text-xs font-semibold rounded-sm ${
                  activeBuySellOption === "buy"
                    ? "bg-p150 text-white"
                    : "bg-n000 text-n500"
                }`}
                onClick={() => handleBuySellToggle("buy")}>
                BUY
              </button>
              <button
                className={`flex-1 text-xs font-semibold rounded-sm ${
                  activeBuySellOption === "sell"
                    ? "bg-red text-white"
                    : "bg-n000 text-n500"
                }`}
                onClick={() => handleBuySellToggle("sell")}>
                SELL
              </button>
            </div>

            {/* Intraday/Normal Radio Buttons */}
            <div className="flex items-center gap-4">
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="tradeType"
                  value="intraday"
                  checked={activeIntradayNormalOption === "intraday"}
                  onChange={() => handleIntradayNormalToggle("intraday")}
                  className="h-4 w-4"
                />
                <span
                  className={`ms-1 text-xs font-semibold uppercase ${
                    activeIntradayNormalOption === "intraday"
                      ? "text-p300"
                      : "text-n500"
                  }`}>
                  INTRADAY
                </span>
              </label>

              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="tradeType"
                  value="normal"
                  checked={activeIntradayNormalOption === "normal"}
                  onChange={() => handleIntradayNormalToggle("normal")}
                  className="h-4 w-4"
                />
                <span
                  className={`ms-1 text-xs font-semibold uppercase ${
                    activeIntradayNormalOption === "normal"
                      ? "text-p300"
                      : "text-n500"
                  }`}>
                  NORMAL
                </span>
              </label>
            </div>
          </div>

          {/* Divider */}
          <div className="border-b border-n200"></div>

          {/* Inputs Section - First Row */}
          <div className="p-4 flex justify-between gap-4">
            {/* Order Type */}
            <div className="w-[155px]">
              <p className="text-xs font-medium text-n400 mb-2">Order Type</p>
              <div className="relative">
                <select
                  className="w-full h-8 px-2 py-1 border border-[#CFCFCF] rounded text-p300 font-medium text-sm appearance-none bg-p400"
                  value={orderType}
                  onChange={(e) => handleOrderTypeChange(e.target.value)}>
                  <option className="hover:bg-n100" value="marketorder">
                    Market
                  </option>
                  <option className="hover:bg-n100" value="limitorder">
                    Limit
                  </option>
                  <option className="hover:bg-n100" value="triggerorder">
                    Stop Limit
                  </option>
                </select>
                <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg
                    className="w-4 h-4 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"></path>
                  </svg>
                </div>
              </div>
            </div>

            {/* Lots */}
            <div className="w-[155px]">
              <p className="text-xs font-medium text-n400 mb-2">Lots</p>
              <div className="flex items-center border border-[#CFCFCF] rounded h-8  px-2">
                <button
                  className="btn btn-sm btn-ghost border-0 text-p300 font-medium px-2"
                  onClick={handleDecrement}>
                  -
                </button>
                <input
                  type="text"
                  className="w-1/2 flex-1 text-center border-0 focus:outline-none text-sm font-medium text-p300 h-full bg-p400"
                  value={lots}
                  onChange={(e) => handleLotSizeChange(e.target.value)}
                  onBlur={handleLotSizeBlur}
                />
                <button
                  className="btn btn-sm btn-ghost border-0 text-p300 font-medium px-2"
                  onClick={handleIncrement}>
                  +
                </button>
              </div>
            </div>
          </div>

          {/* Inputs Section - Second Row */}
          <div className="px-4 pb-4 flex justify-between gap-4">
            {/* Price */}
            <div className="w-[155px]">
              <p className="text-xs font-medium text-n400 mb-2">Price</p>
              <input
                type="text"
                className={`w-full h-8 px-2 py-1 border border-[#CFCFCF] rounded font-medium text-sm ${
                  isPriceEnabled ? "bg-p400 text-p300" : "bg-n200 text-n400"
                }`}
                value={price}
                onChange={(e) => handlePriceChange(e)}
                onKeyDown={(e) => handlePriceKeyPress(e)}
                placeholder="Price"
                disabled={!isPriceEnabled}
              />
              {priceError && (
                <div className="text-red text-xs mt-1">{priceError}</div>
              )}
            </div>

            {/* Trigger Price */}
            <div className="w-[155px]">
              <p className="text-xs font-medium text-n400 mb-2">
                Trigger Price
              </p>
              <input
                type="text"
                className={`w-full h-8 px-2 py-1 border border-[#CFCFCF] rounded font-medium text-sm ${
                  isTriggerPriceEnabled
                    ? "bg-p400 text-p300"
                    : "bg-n200 text-n400"
                }`}
                value={isTriggerPriceEnabled ? trigger_price : "0"}
                onChange={(e) => handleTriggerPriceChange(e)}
                onKeyDown={(e) => handlePriceKeyPress(e)}
                placeholder="0"
                disabled={!isTriggerPriceEnabled}
              />
              {triggerPriceError && (
                <div className="text-red text-xs mt-1">
                  {triggerPriceError}
                </div>
              )}
            </div>
          </div>

          {/* Inputs Section - Third Row - Stoploss and Target */}
          <div className="px-4 pb-4 flex justify-between gap-4">
            {/* Stoploss */}
            <div className="w-[155px]">
              <p className="text-xs font-medium text-n400 mb-2">
                Stoploss (Absolute)
              </p>
              <input
                type="text"
                className={`w-full h-8 px-2 py-1 border border-[#CFCFCF] rounded font-medium text-sm ${
                  isCO || isBO ? "bg-p400 text-p300" : "bg-n200 text-n400"
                }`}
                value={stoploss}
                onChange={handleStoplossChange}
                placeholder="Absolute Stoploss"
                disabled={!isCO && !isBO}
              />
              {stoplossError && (
                <div className="text-red text-xs mt-1">{stoplossError}</div>
              )}
            </div>

            {/* Target */}
            <div className="w-[155px]">
              <p className="text-xs font-medium text-n400 mb-2">
                Target (Absolute)
              </p>
              <input
                type="text"
                className={`w-full h-8 px-2 py-1 border border-[#CFCFCF] rounded font-medium text-sm ${
                  isBO ? "bg-p400 text-p300" : "bg-n200 text-n400"
                }`}
                value={target}
                onChange={handleTargetChange}
                placeholder="Absolute Target"
                disabled={!isBO}
              />
              {targetError && (
                <div className="text-red text-xs mt-1">{targetError}</div>
              )}
            </div>
          </div>

          {/* CO and BO Checkboxes Row */}
          <div className="px-4 pb-4 flex justify-between gap-4">
            {/* CO Checkbox */}
            <div className="w-[155px] flex items-center">
              <input
                type="checkbox"
                checked={isCO}
                onChange={(e) => handleCOCheckbox(e.target.checked)}
                className="h-4 w-4 cursor-pointer"
              />
              <label className="ml-2 text-xs font-semibold text-n400 cursor-pointer">
                CO
              </label>
            </div>

            {/* BO Checkbox */}
            <div className="w-[155px] flex items-center">
              <input
                type="checkbox"
                checked={isBO}
                onChange={(e) => handleBOCheckbox(e.target.checked)}
                className="h-4 w-4 cursor-pointer"
              />
              <label className="ml-2 text-xs font-semibold text-n400 cursor-pointer">
                BO
              </label>
            </div>
          </div>

          {/* Divider */}
          <div className="border-b border-n100"></div>

          {/* Margin Info */}
          <div className="px-4 py-3 flex justify-between">
            <div className="flex flex-col items-center">
              <span className="text-xs font-medium text-n400">Margin</span>
              <span className="text-xs font-medium text-p300">
                ₹ {formatNumberWithCommasAndFontWeight(marginRequired)}
              </span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-xs font-medium text-n400">Charges</span>
              <span className="text-xs font-medium text-p300">
                ₹ {formatNumberWithCommasAndFontWeight(charges)}
              </span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-xs font-medium text-n400">
                Margin Available
              </span>
              <span className="text-xs font-medium text-p300">
                ₹{" "}
                {formatNumberWithCommasAndFontWeight(fundsData.marginAvailable)}
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="p-4 flex gap-3">
            {!isOrders ? (
              <button
                className="flex justify-center items-center gap-2 flex-1 bg-p400 border border-p300 text-p300 text-sm font-semibold h-10 rounded-md"
                onClick={() => {
                  handleAddToBasket();
                  modalClose();
                }}>
                {/* Basket SVG placeholder - replace with your actual SVG from assets */}
                <img
                  src={AddToBasketIcon}
                  alt="basket icon"
                  width={16}
                  height={16}
                  style={{
                    filter:
                      theme === "dark" ? "brightness(0) invert(1)" : "none",
                  }}
                />
                Add to Basket
              </button>
            ) : (
              ""
            )}
            <button
              className="flex justify-center items-center gap-2 flex-1 text-p400 text-sm font-semibold h-10 rounded-md bg-swipe-button"
              onClick={handleExecuteOrder}>
              {/* Tick SVG placeholder - replace with your actual SVG from assets */}
              {theme === "dark" ? (
                <img src={ExecutetickIconDark} alt="" />
              ) : (
                <img src={ExecutetickIconLight} alt="" />
              )}
              Execute
            </button>
          </div>
        </div>
      </div>

      {/* Modal backdrop */}
      <div className="modal-backdrop bg-black/20" onClick={modalClose}></div>

      {/* Enable Live Trades Modal */}
      {/* <CommonModal isOpen={openModal} onClose={() => setOpenModal(!openModal)}>
        <p>Enable Live Trades</p>
      </CommonModal> */}
    </div>
  );
};

export default OrdersBuySellModal;
